/**
 * サイドメニュー（03 7.1）とユーザーメニュー（7.2）。表示の条件は permissions（ロール名で分岐しない：FE-D-025）。
 * 見出しの下の項目が 1 つも出ないとき（一般ユーザーの「管理」）は見出しも出さない。
 */
export interface MenuItemDefinition {
  label: string;
  to: string;
  permission?: string;
}

export interface MenuGroupDefinition {
  heading: string | null;
  is_admin_only?: boolean;
  items: readonly MenuItemDefinition[];
}

export const SIDE_MENU: readonly MenuGroupDefinition[] = [
  {
    // 旧PCRMどおり先頭に見出し「メニュー」とダッシュボードを置く（262）
    heading: 'メニュー',
    items: [
      { label: 'ダッシュボード', to: '/' },
      { label: '顧客', to: '/customers', permission: 'customers:read' },
      { label: '案件', to: '/deals', permission: 'cases:read' },
      { label: '取引', to: '/transactions', permission: 'transactions:read' },
      { label: 'カレンダー', to: '/calendar', permission: 'calendar:read' },
      { label: 'レポート', to: '/reports', permission: 'reports:read' },
      { label: '目標管理', to: '/goals', permission: 'goals:read' },
    ],
  },
  {
    heading: '人材管理',
    items: [
      { label: '要員一覧', to: '/personnel', permission: 'personnel:read' },
      { label: '契約一覧', to: '/contracts', permission: 'contracts:read' },
      { label: 'チェックリスト', to: '/checklists', permission: 'monthly_checklists:read' },
    ],
  },
  {
    heading: 'コミュニケーション',
    items: [{ label: 'コンタクト', to: '/chat-groups', permission: 'contact_threads:read' }],
  },
  {
    heading: 'フォーム',
    items: [
      { label: 'フォーム管理', to: '/forms', permission: 'forms:read' },
      { label: '回答一覧', to: '/submissions', permission: 'form_submissions:read' },
    ],
  },
  {
    heading: '管理',
    is_admin_only: true,
    items: [
      { label: 'ロール管理', to: '/settings/roles', permission: 'roles:update' },
      { label: '監査ログ', to: '/audit-logs', permission: 'audit_logs:read' },
    ],
  },
];

export const USER_MENU: readonly MenuItemDefinition[] = [
  { label: 'ダッシュボード', to: '/' },
  { label: 'マイページ', to: '/mypage' },
  // 管理者だけに出る項目は「（管理者）」を付ける（243 UT-624・625）
  { label: '企業設定（管理者）', to: '/settings/company', permission: 'system_settings:update' },
  { label: 'ユーザー管理（管理者）', to: '/users', permission: 'users:update' },
];

/** 今いる画面の項目を強調する（URL の前方一致） */
export function isMenuItemActive(item_to: string, pathname: string): boolean {
  if (item_to === '/') {
    return pathname === '/';
  }
  return pathname === item_to || pathname.startsWith(`${item_to}/`);
}
